import type { OverviewFeatures } from './type';

export const overview: OverviewFeatures = {
    birthdayGreeting: {
        enabled: true,
        _description: 'Shows a special greeting and animation when it is user birthday.',
    },
};
